import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { Runtime } from "./buildRuntime";

const RuntimeContext = createContext<Runtime | null>(null);

export function RuntimeProvider({ runtime, children }: { runtime: Runtime; children: ReactNode }) {
    return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}

export function useRuntime(): Runtime {
    const runtime = useContext(RuntimeContext);
    if (!runtime) throw new Error("useRuntime must be used within a RuntimeProvider");
    return runtime;
}
